import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import ability from './modules/ability'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    ability
  },
  getters
})
